import React from 'react';
import { Box, Chip, Typography } from '@mui/material';
import ErrorOutlineIcon from '@mui/icons-material/ErrorOutline';
import { CaseValidation } from 'containers/pages/cases/types';

interface MissingFieldsHintProps {
	canNotSave: boolean;
	valid: CaseValidation;
}

const fieldLabels: Record<keyof CaseValidation, string> = {
	Title: 'Title',
	CustomerId: 'Customer',
	ConsultantId: 'Consultant',
	StatusId: 'Status',
};

const MissingFieldsHint: React.FC<MissingFieldsHintProps> = ({ canNotSave, valid }) => {
	if (!canNotSave) return null;

	const missing = (Object.keys(valid) as (keyof CaseValidation)[])
		.filter((key) => valid[key].canNotSave)
		.map((key) => fieldLabels[key]);

	if (missing.length === 0) return null;

	return (
		<Box
			sx={{
				display: 'flex',
				alignItems: 'center',
				gap: 1,
				flexWrap: 'wrap',
				justifyContent: 'flex-end',
			}}
		>
			<ErrorOutlineIcon sx={{ fontSize: '1rem', color: 'error.main' }} />
			<Typography variant="caption" sx={{ color: 'error.main', fontWeight: 500 }}>
				Required:
			</Typography>
			{missing.map((label) => (
				<Chip
					key={label}
					label={label}
					size="small"
					variant="outlined"
					color="error"
					sx={{ height: 22, fontSize: '0.75rem' }}
				/>
			))}
		</Box>
	);
};

export default MissingFieldsHint;
